<div class="step-content-form">
  <div class="step-body">
    <form [formGroup]="propertyBasicInfo">
      <div class="row">
        <div class="column">
          <mat-form-field
            class="mat-form-field-100"
            appearance="outline"
          >
            <mat-label>Property street address</mat-label>
            <input
              matInput
              formControlName="propertyStreetAddress"
              placeholder="Property street address"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="column">
          <mat-form-field
            class="mat-form-field-100"
            appearance="outline"
          >
            <mat-label>Apt/Unit/Suite</mat-label>
            <input
              matInput
              formControlName="aptUnitSuite"
              placeholder="Apt/Unit/Suite"
            />
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <mat-form-field
            class="mat-form-field-100"
            appearance="outline"
          >
            <mat-label>City</mat-label>
            <input matInput formControlName="city" placeholder="City" />
          </mat-form-field>
        </div>

        <div class="column">
          <mat-form-field
            class="mat-form-field-100"
            appearance="outline"
          >
            <mat-label>State</mat-label>

            <mat-select formControlName="state" placeholder="State">
              @for (state of states; track state) {
              <mat-option [value]="state.id">{{ state.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="column">
          <mat-form-field
            class="mat-form-field-100"
            appearance="outline"
          >
            <mat-label>Zip Code</mat-label>
            <input matInput formControlName="zipCode" placeholder="Zip Code" />
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <mat-checkbox color="primary" class="primary">
            I don’t use any platform to rent out my property
            <mat-icon aria-hidden="false" fontIcon="info"></mat-icon>
          </mat-checkbox>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <mat-form-field
            class="mat-form-field-100"
            appearance="outline"
          >
            <mat-label
              >If you use a digital platform, paste link here</mat-label
            >
            <input
              matInput
              placeholder="If you use a digital platform, paste link here"
            />
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
</div>
